import { useSite } from '@/contexts/SiteContext';
import type { OfferingType } from '@/types/offering';

export function useOfferingType(): OfferingType {
  const { selectedSite } = useSite();
  return selectedSite?.offering_type ?? 'product';
}
